// scale of the root model to postpone rounding errors
export const ROOT_SCALE = 1; // window.location.href.includes("projectTree") ? 1 : 10000;
